<div class="db-clone-progress">
  @if (!succeed) {
    <div *ngIf="!fromNotifs" class="db-website-url mb16"><i class="db-icon db-icon-ds-sidebar-domain mr8"></i>
      <span>{{ Utils.replaceUrl(websiteUrl) | middleEllipsis: 35}}</span>
    </div>
    <h1>{{ 'text_websiteCloningInProgress' | dbText }}</h1>
    <p [innerHTML]="'text_cloningDescription' | dbText"></p>

    <div class="db-clone-progress__loading mt32">
      <div class="db-clone-progress__loading-line-base"></div>
      <div class="db-clone-progress__loading-line"></div>
    </div>
  } @else {
    <h1>{{ 'text_websiteClonedSuccessfully' | dbText }}</h1>
    <p class="mb25">{{ 'text_clonedSuccessfully' | dbText }}</p>
    <div class="db-cloned-info" *ngIf="!fromNotifs">
      <div class="db-cloned-info-item">
        <p class="db-title">
          {{ 'text_yourWebsiteUrl' | dbText }}
        </p>
          <a [href]="websiteUrl" target="_blank">{{ Utils.replaceUrl(websiteUrl) | middleEllipsis: 35 }}</a>
      </div>
      <div class="db-cloned-info-item">
        <p class="db-title">
          {{ 'text_locationDataCenter' | dbText }}
        </p>
        <span class="db-datacenter">
        {{dataCenter}}
        </span>
      </div>
    </div>
    <div class="db-button-wrap mt32">
      <button class="ds-btn-outline-eggshell m" (click)="closeDialog()">
        <span>{{'text_cancel' | dbText}}</span>
      </button>
      <a class="db-link-button ds-btn-black ds-btn-m m" [href]="websiteUrl" target='_blank' rel='noopener'><span>{{'text_goToClonedWebsite' | dbText}}</span></a>
    </div>

    }


</div>
